import { render, staticRenderFns } from "./ChatbotSelector.vue?vue&type=template&id=36b243b0&scoped=true"
import script from "./ChatbotSelector.vue?vue&type=script&lang=js"
export * from "./ChatbotSelector.vue?vue&type=script&lang=js"
import style0 from "./ChatbotSelector.vue?vue&type=style&index=0&id=36b243b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b243b0",
  null
  
)

export default component.exports